/*
  * Copyright Mission 42 Ventures, Inc. All rights reserved.
  * Unauthorized copying, distribution, or use is prohibited.
  */

// Shared request-access target for the read-only affordances (P1 / PLAT-254):
// the Home notice (ReadOnlyAccessNotice) and the global permission-denied
// snackbar (RequestAccessOnDenied). Membership in any org team makes a user
// Tier-2 (write); release-engineers owns the request/notify flow. Named
// constants here (could move to app-config later if the target team changes).
export const REQUEST_TEAM_URL =
  'https://github.com/orgs/m42-platform/teams/release-engineers';
export const REQUEST_TEAM_LABEL = 'Release Engineers';
